"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var ScopeAnalyzer_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopeAnalyzer = void 0;
const inversify_1 = require("inversify");
const eslintScope = __importStar(require("eslint-scope"));
const estraverse = __importStar(require("@javascript-obfuscator/estraverse"));
const eslint_visitor_keys_1 = require("eslint-visitor-keys");
const EcmaVersion_1 = require("../../constants/EcmaVersion");
const NodeGuards_1 = require("../../node/NodeGuards");
let ScopeAnalyzer = ScopeAnalyzer_1 = class ScopeAnalyzer {
    constructor() {
        this.scopeManager = null;
    }
    static attachMissingRanges(astTree) {
        estraverse.replace(astTree, {
            enter: (node, parentNode) => {
                var _a, _b, _c, _d;
                if (!node.range) {
                    node.range = [
                        (_b = (_a = parentNode === null || parentNode === void 0 ? void 0 : parentNode.range) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : ScopeAnalyzer_1.emptyRangeValue,
                        (_d = (_c = parentNode === null || parentNode === void 0 ? void 0 : parentNode.range) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : ScopeAnalyzer_1.emptyRangeValue
                    ];
                }
                return node;
            }
        });
    }
    static isRootNode(node) {
        return NodeGuards_1.NodeGuards.isProgramNode(node) || node.parentNode === node;
    }
    analyze(astTree) {
        const sourceTypeLength = ScopeAnalyzer_1.sourceTypes.length;
        ScopeAnalyzer_1.attachMissingRanges(astTree);
        for (let i = 0; i < sourceTypeLength; i++) {
            try {
                this.scopeManager = eslintScope.analyze(astTree, {
                    ...ScopeAnalyzer_1.eslintScopeOptions,
                    sourceType: ScopeAnalyzer_1.sourceTypes[i]
                });
                this.fixAnnexBFunctionHoisting();
                return;
            }
            catch (error) {
                if (i < sourceTypeLength - 1) {
                    continue;
                }
                throw new Error(error);
            }
        }
        throw new Error('Scope analyzing error');
    }
    acquireScope(node) {
        if (!this.scopeManager) {
            throw new Error('Scope manager is not defined');
        }
        const scope = this.scopeManager.acquire(node, ScopeAnalyzer_1.isRootNode(node));
        if (!scope) {
            throw new Error('Cannot acquire scope for node');
        }
        this.sanitizeScopes(scope);
        return scope;
    }
    fixAnnexBFunctionHoisting() {
        if (!this.scopeManager) {
            return;
        }
        this.walkScopes(this.scopeManager.globalScope, (scope) => {
            if (scope.type !== 'block' && scope.type !== 'switch') {
                return;
            }
            if (scope.isStrict) {
                return;
            }
            const functionScope = scope.variableScope;
            if (!functionScope) {
                return;
            }
            for (let i = scope.variables.length - 1; i >= 0; i--) {
                const variable = scope.variables[i];
                const isFunctionDeclaration = variable.defs.some((def) => { var _a; return def.type === 'FunctionName' && ((_a = def.node) === null || _a === void 0 ? void 0 : _a.type) === 'FunctionDeclaration'; });
                if (!isFunctionDeclaration) {
                    continue;
                }
                const outerVariable = functionScope.variables.find((v) => v.name === variable.name && v !== variable);
                const isOuterLetOrConst = outerVariable === null || outerVariable === void 0 ? void 0 : outerVariable.defs.some((def) => { var _a, _b; return def.type === 'Variable' && (((_a = def.parent) === null || _a === void 0 ? void 0 : _a.kind) === 'let' || ((_b = def.parent) === null || _b === void 0 ? void 0 : _b.kind) === 'const'); });
                if (isOuterLetOrConst) {
                    continue;
                }
                const targetVariable = outerVariable !== null && outerVariable !== void 0 ? outerVariable : variable;
                if (outerVariable) {
                    outerVariable.identifiers.push(...variable.identifiers);
                    outerVariable.references.push(...variable.references);
                }
                else {
                    functionScope.variables.push(variable);
                }
                scope.variables.splice(i, 1);
                this.linkThroughReferences(variable.name, functionScope, targetVariable);
            }
        });
    }
    linkThroughReferences(name, scope, targetVariable) {
        for (let i = scope.through.length - 1; i >= 0; i--) {
            if (scope.through[i].identifier.name === name) {
                targetVariable.references.push(scope.through[i]);
                scope.through.splice(i, 1);
            }
        }
        for (const childScope of scope.childScopes) {
            this.linkThroughReferences(name, childScope, targetVariable);
        }
    }
    sanitizeScopes(scope) {
        scope.childScopes.forEach((childScope) => {
            if (childScope.type === 'class' && childScope.upper) {
                if (!childScope.variables.length) {
                    return;
                }
                const classNameVariable = childScope.variables[0];
                const upperVariable = childScope.upper.variables.find((variable) => {
                    const isValidClassNameVariable = classNameVariable.defs.some((definition) => definition.type === 'ClassName');
                    return isValidClassNameVariable && variable.name === classNameVariable.name;
                });
                upperVariable === null || upperVariable === void 0 ? void 0 : upperVariable.references.push(...childScope.variables[0].references);
            }
        });
        for (const childScope of scope.childScopes) {
            this.sanitizeScopes(childScope);
        }
    }
    walkScopes(scope, callback) {
        callback(scope);
        for (const childScope of scope.childScopes) {
            this.walkScopes(childScope, callback);
        }
    }
};
exports.ScopeAnalyzer = ScopeAnalyzer;
ScopeAnalyzer.eslintScopeOptions = {
    ecmaVersion: EcmaVersion_1.ecmaVersion,
    childVisitorKeys: eslint_visitor_keys_1.KEYS,
    optimistic: true
};
ScopeAnalyzer.sourceTypes = ['script', 'module'];
ScopeAnalyzer.emptyRangeValue = 0;
exports.ScopeAnalyzer = ScopeAnalyzer = ScopeAnalyzer_1 = __decorate([
    (0, inversify_1.injectable)()
], ScopeAnalyzer);
